import React from "react";
import { PropTypes } from "prop-types";
import { Button, Container, withModal, withStyles } from "components/common";
import mastercard from "assets/payment/mastercard.png";
import visa from "assets/payment/visa.png";
import googlepay from "assets/payment/googlePay.png";
import applepay from "assets/payment/applePay.png";
import cashapp from "assets/payment/cashApp.png";
import { compose } from "redux";

const altPaymentIcons = [
  { name: "mastercard", url: mastercard },
  { name: "visa", url: visa },
  { name: "google pay", url: googlepay },
  { name: "apple pay", url: applepay },
  { name: "cash app", url: cashapp },
];

const PaymentIcon = ({ imageUrl, name }) => {
  return (
    <img
      className="w-auto h-5 object-contain mb-1 mx-1"
      src={imageUrl}
      alt={name}
    />);
};

PaymentIcon.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

const PaymentAlternative = ({
  user,
}) => {
  if (!user?.alternative_payment_link) {
    return null;
  }
  return (
    <div className="h-full w-full">
      <Container paddingVertical={16} className="w-full flex-1 h-full">
        <div className="flex flex-col text-center h-full justify-center">
          <p className="font-bold mr-1 text-xl mb-2">Make a payment</p>
          <div>
            {/* <p className="mr-1 text-xs mb-2">through credit card, Cash App, and more</p> */}
            <div className="flex justify-center mb-2">
              {
                altPaymentIcons.map(
                  ({ name, url }) => (
                    <PaymentIcon name={name} key={`icon-${name}`} imageUrl={url} />
                  ),
                )
              }
            </div>
          </div>
          <Button
            className="mb-2 w-64"
            onClick={
              () => window.open(user.alternative_payment_link)
            }
          >
            <p className="px-6">Pay</p>
          </Button>
        </div>
      </Container>
    </div>
  );
};

PaymentAlternative.propTypes = {
  user: PropTypes.shape({
    alternative_payment_link: PropTypes.string,
  }).isRequired,
};

export default compose(withStyles, withModal)(PaymentAlternative);
